import {
  ToitEnPenteConfigurationState,
  ToitEnPenteThermalPerformanceState,
  FEMaterial,
} from "@iko-design-center/shared"
import { useCallback } from "react"
import { useAppDispatch, useAppSelector } from "../hooks"
import { DownloadState } from "./download"
import { toitEnPenteSlice } from "./store"

export function useToitEnPente() {
  const dispatch = useAppDispatch()
  const toitEnPenteState = useAppSelector((state) => state.toitEnPente)
  const configurationState = useAppSelector(
    (state) => state.toitEnPente.configuration
  )
  const downloadState = useAppSelector((state) => state.toitEnPente.download)
  const thermalPerformance = useAppSelector(
    (state) => state.toitEnPente.thermalPerformance
  )
  const toitEnPenteScreenshots = useAppSelector(
    (state) => state.toitEnPente.screenshots
  )

  const setToitInsulationType = useCallback(
    (type: any) => {
      dispatch(toitEnPenteSlice.actions.setToitInsulationType(type))
    },
    [dispatch]
  )
  const setToitInsulationTypeWithThickness = useCallback(
    (type: any, thickness: string) => {
      dispatch(
        toitEnPenteSlice.actions.setToitInsulationTypeWithThickness({
          type,
          thickness,
        })
      )
    },
    [dispatch]
  )
  const setToitClimateType = useCallback(
    (type: any) => {
      dispatch(toitEnPenteSlice.actions.setToitClimateType(type))
    },
    [dispatch]
  )
  const setToitStructureType = useCallback(
    (type: any) => {
      dispatch(toitEnPenteSlice.actions.setToitStructureType(type))
    },
    [dispatch]
  )
  const setToitRainCoverType = useCallback(
    (type: any) => {
      dispatch(toitEnPenteSlice.actions.setToitRainCoverType(type))
    },
    [dispatch]
  )
  const setToitAcousticLayerType = useCallback(
    (type: any) => {
      dispatch(toitEnPenteSlice.actions.setToitAcousticLayerType(type))
    },
    [dispatch]
  )

  const setToitInsulationMaterial = useCallback(
    (material: FEMaterial) => {
      dispatch(toitEnPenteSlice.actions.setToitInsulationMaterial(material))
    },
    [dispatch]
  )

  const setThermalPerformance = useCallback(
    (thermalPerformance: ToitEnPenteThermalPerformanceState) => {
      dispatch(
        toitEnPenteSlice.actions.setThermalPerformance(thermalPerformance)
      )
    },
    [dispatch]
  )

  const resetConfigurationToClimate = useCallback(
    () => dispatch(toitEnPenteSlice.actions.resetConfigurationToClimate()),
    [dispatch]
  )
  const resetConfigurationToStructure = useCallback(
    () => dispatch(toitEnPenteSlice.actions.resetConfigurationToStructure()),
    [dispatch]
  )
  const resetConfigurationToRainCover = useCallback(
    () => dispatch(toitEnPenteSlice.actions.resetConfigurationToRainCover()),
    [dispatch]
  )

  const setConfiguration = useCallback(
    (configuration: ToitEnPenteConfigurationState) =>
      dispatch(toitEnPenteSlice.actions.setConfiguration(configuration)),
    [dispatch]
  )

  const setHumanReadableName = useCallback(
    (name: string) =>
      dispatch(toitEnPenteSlice.actions.setHumanReadableName(name)),
    [dispatch]
  )

  const resetConfiguration = useCallback(
    () => dispatch(toitEnPenteSlice.actions.resetConfiguration()),
    [dispatch]
  )

  const setDownloadState = useCallback(
    (downloadState: DownloadState) =>
      dispatch(toitEnPenteSlice.actions.setDownloadState(downloadState)),
    [dispatch]
  )

  const addScreenshot = useCallback(
    (dataURL: string) =>
      dispatch(toitEnPenteSlice.actions.addScreenshot(dataURL)),
    [dispatch]
  )

  const setOverviewScreenshot = useCallback(
    (dataURL: string) =>
      dispatch(toitEnPenteSlice.actions.setOverviewScreenshot(dataURL)),
    [dispatch]
  )

  return {
    toitEnPenteState,
    addScreenshot,
    setOverviewScreenshot,
    toitEnPenteScreenshots,
    thermalPerformance,
    setThermalPerformance,
    downloadState,
    configurationState,

    setToitInsulationType,
    setToitInsulationTypeWithThickness,
    setToitClimateType,
    setToitStructureType,
    setToitRainCoverType,
    setToitAcousticLayerType,
    setToitInsulationMaterial,

    setConfiguration,
    setHumanReadableName,
    setDownloadState,
    resetConfigurationToClimate,
    resetConfigurationToStructure,
    resetConfigurationToRainCover,
    resetConfiguration,
  }
}
